import React, { Fragment, useCallback } from 'react';
import './ChatContact.css';
//import clientIcon from '../../../../assets/clientIcon.png';
import whatsapp from '../../../../assets/whatsapp.png';
import sms from '../../../../assets/sms.png';
import instagram from '../../../../assets/instagram.png';
import messenger from '../../../../assets/messenger.png';
import mail from '../../../../assets/mail.png'
import companyIcon from '../../../../assets/home.png'
import facebookIcon from '../../../../assets/facebook.png'
import youtube from '../../../../assets/youtubeIcon.png'
import instagram_direct from '../../../../assets/instagram_direct.png'
import leadIcon from '../../../../assets/lead3.jpg'
import webchat from '../../../../assets/webchaticon.png'
import { useTranslation } from "react-i18next";

const ChatContact = (props) => {
    const [t] = useTranslation('common')
    const appAccess = props.appAccess
    let cardColor = 'row card chatCard'
    let icon = null
    let groupIcon = undefined
    if (props.groupList && props.groupList.length > 0) {
        let title = ""
        let i = 0
        for (let group of props.groupList) {
            title += group.groupName
            if (i < props.groupList.length - 1) {
                title += '\n'
            }
            i++
        }

        groupIcon = <i title={title} className='fa-solid fa-people-group status-icon' />
    }
    if (props.msgType === 'whatsapp') {
        icon = whatsapp
    }
    else if (props.msgType === 'sms') {
        icon = sms
    }
    else if (props.msgType === 'instagram') {
        icon = instagram_direct
    }
    else if (props.msgType === 'messenger') {
        icon = messenger
    }
    else if (props.msgType === 'mail') {
        icon = mail
    }
    else if (props.msgType === 'company') {
        icon = companyIcon
    }
    else if (props.msgType === 'facebook') {
        icon = facebookIcon
    }
    else if (props.msgType === 'ig_media') {
        icon = instagram
    }
    else if (props.msgType === 'lead') {
        icon = leadIcon
    }
    else if (props.msgType === 'youtube') {
        icon = youtube
    }
    else if (props.msgType === 'webchat') {
        icon = webchat
    }
    if (!props.selectMultipleBtnClicked && (props.nowChatSelected === props.senderName && props.nowSelectedChannel === props.msgType)) {
        cardColor = 'row card chatCard chatCardOnSelect'
    }
    else if (props.selectMultipleBtnClicked && props.isChatMultiSelected) {
        cardColor = 'row card chatCard chatCardOnSelect'
    }
    let title = null
    if (!props.name) {
        title = props.senderName?.replace('+972', '0')
    }
    else {
        title = props.name
    }
    let toSeeCount = props.notSeenCount - props.seenCount
    let statusIcon = undefined
    if (props.completed) {//closed status
        statusIcon = <i title={t('Closed Inquiry')} className="fas fa-battery-full status-icon conv-status-icon " />
    }
    else if (!props.completed && props.isPublic) {// new inqu
        statusIcon = <i title={t('New Inquiry')} className="fas fa-battery-empty status-icon conv-status-icon " />
    }
    else if (!props.completed && !props.isPublic) {// in progress
        statusIcon = <i title={t('in-progress Inquiry')} className="fas fa-battery-half status-icon conv-status-icon " />
    }

    const OnNewConvChannelSelected = props.OnNewConvChannelSelected
    const onNewConvName = props.onNewConvName
    const OnNewConvClicked = props.OnNewConvClicked
    const onChannelSelect = useCallback((channelId, msgType, event) => {
        event.stopPropagation();
        OnNewConvChannelSelected(msgType)
        onNewConvName(channelId)
        setTimeout(() => OnNewConvClicked(), 0)

    }, [OnNewConvClicked, onNewConvName, OnNewConvChannelSelected])

    return (
        <Fragment>
            <div className={cardColor} onClick={props.chatSelected}>
                <div className='col-10 col-md-9 costContactsTextCol'>
                    <div className='card-body chatCardBody'>
                        <div className='mutedP'>
                            <span className='lastMsgDateSpan'>{props.lastDate}</span>
                            {appAccess !== 'DIALER' && <div className='convStatusSpan'>
                                {groupIcon}
                                {statusIcon}
                            </div>}
                        </div>
                        <p className='contactCardTitleChat'>
                            {toSeeCount !== 0 && !(props.nowChatSelected === props.senderName && props.nowSelectedChannel === props.msgType) && <span className='notSeenCountChat'>{toSeeCount}</span>}
                            {title}
                        </p>
                        <p className='contactCardChatText'>{props.lastMsg}</p>
                        <div className='contactCardActions'>
                            {/* All icons except the conditionally rendered ones are aligned to the left */}
                            {(props.msgType === 'whatsapp' || props.msgType === 'sms' || props.msgType === 'lead') && props.device &&
                                <i onClick={props.CallBtClicked} className="fas fa-phone-square toCallInChatCard margin-right--5px"></i>
                            }

                            {appAccess !== 'DIALER' && ((props.msgType === 'whatsapp' || props.msgType === 'lead')) &&
                                <i className="fas fa-sms chatContact_channelsPanel_sms margin-right--5px" onClick={(event) => onChannelSelect(props.senderName.split('_')[0], 'sms', event)} />
                            }
                            {appAccess !== 'DIALER' && ((props.msgType === 'sms' || props.msgType === 'lead')) &&
                                <i className="fab fa-whatsapp-square chatContact_channelsPanel_whatsapp margin-right--5px" onClick={(event) => onChannelSelect(props.senderName.split('_')[0], 'whatsapp', event)} />
                            }

                            {/* Container for icons that need to be aligned to the right */}
                            <div className="iconsAlignRight">
                                {(props.msgType === 'sms' || props.msgType === 'whatsapp' || props.msgType === 'mail') && (
                                    props.isContactIdAvailabileMsg?._id ?
                                        <i className="fa-regular fa-pen-to-square chatContact_channelsPanel_contactList" onClick={() => props.onContactListBtnClicked('edit', 'CONV')}></i> :
                                        <i className="fa-solid fa-plus chatContact_channelsPanel_contactList" onClick={() => props.onContactListBtnClicked('add', 'CONV')}></i>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-2 col-md-3 channelIconCol'>
                    <div className='userIcon'>
                        {/* <img src={icon} className='convChannelImg' alt='...' /> */}
                        <img src={icon} className={props.msgType === 'webchat' ? 'convChannelImgWithoutBorderRadius' : 'convChannelImg'} alt='...' />
                    </div>
                    {props.channelName &&
                        <span className='convChannelName'>{props.channelName}</span>
                    }
                </div>
            </div>
            <hr className="dividingLineBetChats" />
        </Fragment>
    );
};

export default ChatContact;